
export default () => ({
  events: [],
  tours: [],
  sale: {
    description: null,
    checkInDate: null,
    duration: 0,
    isHotel: false,
    price: {
      amount: 0,
      markup: 0,
      currency: null
    },
    serviceId: 1,
    image: null,
    name: null,
    category: null,
    rating: null,
    city: null,
    redirectInfo: {
      cart: null,
      search: {
        placeId: null,
        placeType: null,
        checkInDate: null,
        duration: 0,
        hotelSearchId: null,
        hasMore: 1,
        rooms: [
          {
            adults: 0,
            children: 0,
            ages: []
          }
        ],
        isRepeatedSearch: 0,
        currency: null
      }
    }
  },
  hasErrors: false
})
